module.exports = __webpack_public_path__ + "img/apple.38a779db.svg";